<template>
  <div class="grid gap-5">
    <l-select
      v-model="user.finances.target_debt_period"
      label="Term"
      name="target_debt_period"
      class="field:max-w-xs"
      help="The period over which you will make your monthly debt payments."
      :items="[
        [10, '10 years'],
        [20, '20 years'],
        [25, '25 years'],
      ]"
    />

    <l-input
      v-model="user.finances.target_tax"
      label="Target debt service"
      name="target_tax"
      class="field:max-w-xs"
      type="number"
      suffix="%"
      :gstmin="0"
      help="Percentage of your salary that you'd like to go towards your monthly debt payments."
    />
  </div>
</template>

<script setup>
import LInput from "@/components/inputs/LInput.vue"
import LSelect from "@/components/inputs/LSelect.vue"

const user = defineModel({ type: Object, required: true })
</script>
